// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  DESKTOP GRID  */
.parent-corpSum {
  width: 95%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  box-sizing: border-box;
  overflow-x: hidden;
}

.div1-corpSum { grid-area: 1 / 1 / 2 / 3; }
.div3-corpSum { grid-area: 2 / 1 / 3 / 3; }
.div4-corpSum { grid-area: 1 / 3 / 2 / 5; }
.div5-corpSum { grid-area: 2 / 3 / 3 / 5; }
.div6-corpSum { grid-area: 1 / 5 / 3 / 8; }
.div10-corpSum { grid-area: 4 / 1 / 6 / 8; }
.div11-corpSum { grid-area: 6 / 1 / 8 / 8; }
.div9-corpSum { grid-area: 8 / 1 / 10 / 8; }
.div8-corpSum { grid-area: 10 / 1 / 12 / 4; }
.div7-corpSum { grid-area: 10 / 4 / 12 / 8; }

.panel {
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 10px 17px;
  background: #fff;
  border: 1px solid #d4d4d4;
  box-sizing: border-box;
  overflow-x: auto;
  transition: all 0.2s ease;
}

/*  MOBILE STACK GRID  */
@media (max-width: 851px) {
  .parent-corpSum {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      "div1"
      "div3"
      "div4"
      "div5"
      "div6"
      "div10"
      "div11"
      "div9"
      "div8"
      "div7";
    gap: 15px;
    padding: 10px;
  }

  .div1-corpSum { grid-area: div1; }
  .div3-corpSum { grid-area: div3; }
  .div4-corpSum { grid-area: div4; }
  .div5-corpSum { grid-area: div5; }
  .div6-corpSum { grid-area: div6; }
  .div10-corpSum { grid-area: div10; }
  .div11-corpSum { grid-area: div11; }
  .div9-corpSum { grid-area: div9; }
  .div8-corpSum { grid-area: div8; }
  .div7-corpSum { grid-area: div7; }

  .panel {
    width: 100%;
    padding: 10px;
    overflow-x: auto;
  }
}

/* widgets */
.firstWidget {
  background-color: #759EB8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.text-value {
  color: #fff;
  text-align: center;
}

.text-title {
  color: #fff;
  font-size: 12px;
}

/*  tablas  */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive table {
  width: 100%;
  table-layout: auto;
}

/* Tabla consumos y emision co2 */

.table-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}

.table-scroll-vertical {
  max-height: 450px;
  overflow-y: auto;
  position: relative;
}

.table-wrapper table {
  width: 100%;
  min-width: 600px;
  table-layout: auto;
  border-collapse: collapse;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/DashboardCorpSummary/CorporateSummary.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gBAAgB,wBAAwB,EAAE;AAC1C,gBAAgB,wBAAwB,EAAE;AAC1C,gBAAgB,wBAAwB,EAAE;AAC1C,gBAAgB,wBAAwB,EAAE;AAC1C,gBAAgB,wBAAwB,EAAE;AAC1C,iBAAiB,wBAAwB,EAAE;AAC3C,iBAAiB,wBAAwB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,0BAA0B,EAAE;AAC5C,gBAAgB,0BAA0B,EAAE;;AAE5C;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;IACb,0BAA0B;IAC1B;;;;;;;;;;YAUQ;IACR,SAAS;IACT,aAAa;EACf;;EAEA,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,iBAAiB,gBAAgB,EAAE;EACnC,iBAAiB,gBAAgB,EAAE;EACnC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;EACjC,gBAAgB,eAAe,EAAE;;EAEjC;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,iCAAiC;;AAEjC;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B","sourcesContent":["/*  DESKTOP GRID  */\n.parent-corpSum {\n  width: 95%;\n  margin: auto;\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.div1-corpSum { grid-area: 1 / 1 / 2 / 3; }\n.div3-corpSum { grid-area: 2 / 1 / 3 / 3; }\n.div4-corpSum { grid-area: 1 / 3 / 2 / 5; }\n.div5-corpSum { grid-area: 2 / 3 / 3 / 5; }\n.div6-corpSum { grid-area: 1 / 5 / 3 / 8; }\n.div10-corpSum { grid-area: 4 / 1 / 6 / 8; }\n.div11-corpSum { grid-area: 6 / 1 / 8 / 8; }\n.div9-corpSum { grid-area: 8 / 1 / 10 / 8; }\n.div8-corpSum { grid-area: 10 / 1 / 12 / 4; }\n.div7-corpSum { grid-area: 10 / 4 / 12 / 8; }\n\n.panel {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  padding: 10px 17px;\n  background: #fff;\n  border: 1px solid #d4d4d4;\n  box-sizing: border-box;\n  overflow-x: auto;\n  transition: all 0.2s ease;\n}\n\n/*  MOBILE STACK GRID  */\n@media (max-width: 851px) {\n  .parent-corpSum {\n    display: grid;\n    grid-template-columns: 1fr;\n    grid-template-areas:\n      \"div1\"\n      \"div3\"\n      \"div4\"\n      \"div5\"\n      \"div6\"\n      \"div10\"\n      \"div11\"\n      \"div9\"\n      \"div8\"\n      \"div7\";\n    gap: 15px;\n    padding: 10px;\n  }\n\n  .div1-corpSum { grid-area: div1; }\n  .div3-corpSum { grid-area: div3; }\n  .div4-corpSum { grid-area: div4; }\n  .div5-corpSum { grid-area: div5; }\n  .div6-corpSum { grid-area: div6; }\n  .div10-corpSum { grid-area: div10; }\n  .div11-corpSum { grid-area: div11; }\n  .div9-corpSum { grid-area: div9; }\n  .div8-corpSum { grid-area: div8; }\n  .div7-corpSum { grid-area: div7; }\n\n  .panel {\n    width: 100%;\n    padding: 10px;\n    overflow-x: auto;\n  }\n}\n\n/* widgets */\n.firstWidget {\n  background-color: #759EB8;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.text-value {\n  color: #fff;\n  text-align: center;\n}\n\n.text-title {\n  color: #fff;\n  font-size: 12px;\n}\n\n/*  tablas  */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-responsive table {\n  width: 100%;\n  table-layout: auto;\n}\n\n/* Tabla consumos y emision co2 */\n\n.table-wrapper {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  box-sizing: border-box;\n}\n\n.table-scroll-vertical {\n  max-height: 450px;\n  overflow-y: auto;\n  position: relative;\n}\n\n.table-wrapper table {\n  width: 100%;\n  min-width: 600px;\n  table-layout: auto;\n  border-collapse: collapse;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
